import * as PIXI    from "pixi.js";
import HandleButton from "./HandleButton";

export default class  extends PIXI.Container
{
    constructor(url = "", bounds = null, type = "image")
    {
        super();

        if (url === "")
        {
            return
        }
        this.type = type;
        this.url = url;

        this.offset_btn = 15;

        this.mode = "scale";
        this.velocity = {x: 0, y:0}
        this.arrPrevious = [];
        this.isFlip = false;
        this.playing = [];
        this.delaytimeout = [];

        this.id = (Math.random() * 1000) >> 0;

        this.build(bounds)
    }

    setAudioManager (audioManager)
    {
        this.audioManager = audioManager;
    }

    setSfx (sfx)
    {
        this.sfx = sfx;
    }

    setAnim (anim)
    {
        this.anim = anim;
    }
    async  build (bounds)
    {

        let loader = PIXI.Loader.shared;

        if (!loader.resources[this.url])
        {
            loader.add(this.url, this.url /*+ "?" + Math.random()*/);


            loader.load( (loader, resources) =>
                         {
                             const resource = resources[this.url];
                             this.doBuildSprite(resource.texture, bounds);
                         });
        }
        else
        {
            const resource = loader.resources[this.url];
            setTimeout( () => this.doBuildSprite(resource.texture, bounds), 1);
        }
    }

    doBuildSprite (texture, bounds)
    {
        this.sprite = new PIXI.Sprite(texture);


        this.sprite.width = parseInt(bounds.width);
        this.sprite.height = parseInt(bounds.height);
        this.sprite.anchor.x = this.sprite.anchor.y = 0.5;
        this.x = bounds.x + (this.sprite.width / 2);
        this.y = bounds.y + (this.sprite.height / 2);


        this.addChild(this.sprite);

        if (this.type === "animation")
        {
            setTimeout( () => this.buildAnimation(bounds), 4);
        }

        this.buildContainer();
    }
    buildAnimation (bounds)
    {
        let resources = PIXI.Loader.shared.resources;
        let urlAnimation = this.anim.url;

        if (!resources[urlAnimation])
        {
            PIXI.Loader.shared.add(urlAnimation, urlAnimation + "?" + Math.random());
            PIXI.Loader.shared.load ( () => this.onAnimationLoaded(bounds));

        }
        else
        {
            this.onAnimationLoaded(bounds);
        }


    }

    play ()
    {
        if (this.type === "animation")
        {
            if (this.sprite.width === 0 || this.sprite.height === 0)
            {
                this.playSfx(true);
                return;
            }

            this.sprite.visible = false;



            this.animation.width = (this.sprite.width);
            this.animation.height = (this.sprite.height);
            this.animation.rotation = (this.sprite.rotation);

            this.animation.loop = this.anim.loop;

            if (!this.anim.loop)
            {
                this.animation.onComplete = this.onAnimComplete.bind(this);
            }
            this.addChild(this.animation);

            this.animation.gotoAndStop(0);
            let startTimeout = this.calculateRandWait(this.anim.startMinWait, this.anim.startMaxWait)
            let idStartInterval = setTimeout(() => this.playAnimationAgain(true), startTimeout);


        }
        else
        {
            this.playSfx(true);
        }



    }

    calculateRandWait (min, max)
    {
        if (!min )
            min = 0;

        if (!max)
            max = 0;

        let range = parseInt(max) - parseInt(min);
        let next = parseInt(min) + (range * Math.random());

        next = (next * 1000) >> 0;

        return next
    }

    onAnimComplete ()
    {
        let next = this.calculateRandWait(this.anim.minWait, this.anim.maxWait)
        this.animTimeout = setTimeout(() => this.playAnimationAgain(), next);
    }

    playAnimationAgain (start = false)
    {
        console.log("playAnimationAgain")
        this.animation.gotoAndPlay(0);


        this.playSfx(start);

    }

    playSfx (start = false)
    {
        for (let i = 0 ; i < (this.sfx ?? []).length; i++)
        {
            let oneSfx = this.sfx[i];

            if ((parseInt(oneSfx.syncOnAnimation ?? 0) === 1) || start)
            {
                if (parseInt(oneSfx.syncOnAnimation ?? 0) === 1)
                {
                    let id = this.audioManager.playOne(oneSfx);
                    this.playing.push(id);
                }
                else
                {
                    this.prepareDelaySound(oneSfx);
                }
            }
        }
    }

    prepareDelaySound (sfx)
    {
        if (sfx.loop === 1)
        {
            let id = this.audioManager.playOne(sfx);
            this.playing.push(id);
        }
        else
        {
            let wait = this.calculateRandWait(sfx.startMinWait, sfx.startMaxWait);


            let delayId = setTimeout(() =>
                                     {
                                         let id = this.audioManager.playOne(sfx, this.replaySound.bind(this));
                                         this.playing.push(id);
                                     }, wait)

            this.delaytimeout.push(delayId);
        }

    }

    replaySound (sfx)
    {
        let shouldRepeated = parseInt(sfx.isRepeated ?? 0) == 1;

        if (!shouldRepeated)
        {
            return;
        }

        let wait = this.calculateRandWait(sfx.repeatMinWait, sfx.repeatMaxWait);


        let delayId = setTimeout(() =>
                                 {
                                     let id = this.audioManager.playOne(sfx, this.replaySound.bind(this));
                                     this.playing.push(id);
                                 }, wait)

        this.delaytimeout.push(delayId);

        console.log("replaySound", sfx)
    }

    onAnimChange ()
    {
        console.log("anim change");
        //this.alpha = 0.5;
    }
    pause ()
    {
        if (this.delaytimeout.length > 0)
        {
            for (let i = 0; i < this.delaytimeout.length; i++)
            {
                let id = this.delaytimeout[i];
                clearInterval(id);
            }

            this.delaytimeout = [];
        }

        if (this.type === "animation")
        {
            if (this.animTimeout)
            {
                clearInterval(this.animTimeout);
            }

            this.animation.stop();
            this.sprite.visible = true;
            this.removeChild(this.animation);
        }

        for( let i = 0; i < this.playing.length; i++)
        {
            this.audioManager.stop(this.playing[i]);
        }

        this.playing = [];
    }

    onAnimationLoaded (bounds)
    {
        let urlAnimation = this.anim.url;
        let resources =  PIXI.Loader.shared.resources;
        let resource =  resources[urlAnimation];

        let textures = resource.textures;

        if (!textures)
        {
            return;
        }

        let arrTextures = Object.values(textures)

        this.animation = new PIXI.AnimatedSprite(arrTextures, true);

        let fps = parseInt(this.anim.fps ?? 10);
        this.animation.animationSpeed = fps / 60;

        this.animation.width = parseInt(bounds.width);
        this.animation.height = parseInt(bounds.height);
        this.animation.anchor.x = this.animation.anchor.y = 0.5;

       // this.animation.play();

        //this.removeChild(this.sprite);
        //this.addChild (this.animation);

    }
    buildContainer()
    {
        this.gfxBorder = new PIXI.Graphics();

        this.addChild(this.gfxBorder);


        this.contHandle = new PIXI.Container();
        this.addChild(this.contHandle);

        //this.startTransform();



        setTimeout( () => this.bindEvents (), 20);
    }

    copySettings (asset)
    {
        this.sprite.scale.x = asset.sprite.scale.x;
        this.sprite.scale.y = asset.sprite.scale.y;
        this.anim = asset.anim;
        this.sfx = asset.sfx;
        this.audioManager = asset.audioManager;
        this.type = asset.type;
        this.type = asset.type;
        this.isFlip = asset.isFlip;

        this.changeMode(asset.mode);

        this.contHandle.rotation =
        this.gfxBorder.rotation =
        this.sprite.rotation = asset.sprite.rotation;

    }

    bindEvents ()
    {

        //this.buttonMode = true;

        this.fctDragStart = this.onDragStart.bind(this)
        this.fctDrag = this.onDrag.bind(this)
        this.fctDragEnd = this.onDragEnd.bind(this)
        this.fctStartTransform = this.startTransform.bind(this)
        this.fctMoveHandle = this.moveHandle.bind(this)

        this.fctRemoveTransform = this.removeTransform.bind(this)
        this.fctFlip = this.flip.bind(this)
        this.fctScaleMode = this.changeMode.bind(this, "scale")
        this.fctRotateMode = this.changeMode.bind(this, "rotate")

        this.sprite.on("pointerdown", this.fctStartTransform)
        this.sprite.interactive = true;


        //this.buildButton ()

        this.buildHandle();
        this.placeHandle();
    }

    // buildButton () //not used anymore
    // {
    //     this.btnScale = new ActionButton("/images/collage/btn_scale.png");
    //     this.btnRotate = new ActionButton("/images/collage/btn_rotate.png");
    //     this.btnFlip = new ActionButton("/images/collage/btn_flip.png");
    //     this.btnValider = new ActionButton("/images/collage/btn_valider.png");
    //
    //     this.addChild (this.btnScale);
    //     this.addChild (this.btnRotate);
    //     this.addChild (this.btnFlip);
    //     this.addChild (this.btnValider);
    //
    //     this.btnFlip.interactive = true;
    //     this.btnFlip.on("pointerup", this.fctFlip)
    //
    //     this.btnScale.interactive = true;
    //     this.btnScale.on("pointerup", this.fctScaleMode)
    //
    //     this.btnRotate.interactive = true;
    //     this.btnRotate.on("pointerup", this.fctRotateMode)
    //
    //     this.btnValider.interactive = true;
    //     this.btnValider.on("pointerup", this.fctRemoveTransform )
    //
    //
    //     this.hideButton()
    // }

    buildHandle ()
    {
        this.handleTL = new HandleButton("tl", this.mode);
        this.handleTR = new HandleButton("tr", this.mode);
        this.handleBL = new HandleButton("bl", this.mode);
        this.handleBR = new HandleButton("br", this.mode);
        //this.handleCenter = new HandleButton("center");


        this.handleTL.on("move-handle", this.fctMoveHandle)
        this.handleTR.on("move-handle", this.fctMoveHandle)
        this.handleBL.on("move-handle", this.fctMoveHandle)
        this.handleBR.on("move-handle", this.fctMoveHandle)


        this.contHandle.addChild(this.handleTL);
        this.contHandle.addChild(this.handleTR);
        this.contHandle.addChild(this.handleBL);
        this.contHandle.addChild(this.handleBR);
        //this.addChild(this.handleCenter);



        this.hideHandle();
    }

    placeHandle ()
    {
        this.handleTL.x = (-this.sprite.width / 2);// - (this.handleTL.width / 2);
        this.handleTL.y = (-this.sprite.height / 2);// -  (this.handleTL.height / 2);

        this.handleTR.x = (this.sprite.width / 2);// - (this.handleTR.width / 2);
        this.handleTR.y = (-this.sprite.height / 2) ;//-  (this.handleTR.height / 2);


        this.handleBL.x = (-this.sprite.width / 2);// - (this.handleBL.width / 2);
        this.handleBL.y = (this.sprite.height / 2);// -  (this.handleBL.height / 2);

        this.handleBR.x = (this.sprite.width / 2);// - (this.handleBR.width / 2);
        this.handleBR.y = (this.sprite.height / 2);// -  (this.handleBR.height / 2);
    }

    changeMode (mode, event)
    {
        this.mode = mode;

        if (this.handleTR)
        {
            this.handleTL.changeMode(mode);
            this.handleTR.changeMode(mode);
            this.handleBL.changeMode(mode);
            this.handleBR.changeMode(mode);
        }

    }

    moveHandle (event)
    {

        if (this.mode === "scale")
        {
            this.applyScale(event)
        }
        else if (this.mode === "rotate")
        {
            this.applyRotate(event);
        }

        // let pt = this.toGlobal({x: this.handleTL.x, y: this.handleTL.y})
        // this.x = pt.x + (this.sprite.width / 2)
        // this.y = pt.y + (this.sprite.height / 2);

    }

    findAngle (pt1, pt2)
    {
        let diffX = pt1.x - pt2.x;
        let diffY = pt1.y - pt2.y;

        return  Math.atan2(diffY, diffX);

    }

    applyRotate (event)
    {

        let startDragPosition = event.handle.startDragPosition;
        let pos = {x: this.x, y: this.y};
        let mouse = {x: event.event.x, y: event.event.y};


        let angleStart = this.findAngle(startDragPosition, pos);
        let angleCurrent = this.findAngle(mouse, pos);


        this.contHandle.rotation =
        this.gfxBorder.rotation =
        this.sprite.rotation = event.handle.spriteStartInfo.rotation + (angleCurrent - angleStart)

        console.log(angleStart, angleCurrent, 180 / Math.PI  * angleStart, 180 / Math.PI  * angleCurrent);

        this.drawTransformBorder();

        return;

        /*
        let handleType = event.handle.handleType;
        let startAngle = Math.atan2(event.handle.spriteStartInfo.y, event.handle.spriteStartInfo.x);


        let offsetAngle = startAngle - event.handle.spriteStartInfo.rotation;

        let angle = Math.atan2(event.handle.y, event.handle.x);;*/

        // if (handleType === "tl")
        // {
        //     angle = 0;
        // }
        // else if (handleType === "tr")
        // {
        //     angle = Math.atan2(event.handle.y, event.handle.x);
        // }
        // else if (handleType === "bl")
        // {
        //     angle = 0;
        // }
        // else if (handleType === "br")
        // {
        //     angle = 0;
        // }



        this.contHandle.rotation =
        this.sprite.rotation = (angle - offsetAngle);;

        //this.gfxBorder.rotation = -this.sprite.rotation;

        let sad = 180 / Math.PI * startAngle;
        let stad = 180 / Math.PI * event.handle.spriteStartInfo.rotation;
        let od = 180 / Math.PI * offsetAngle;
        let ad = 180 / Math.PI * angle;
        let rd = 180 / Math.PI * this.rotation;

        console.log("startAngle", sad)
        console.log("start rotation", stad)
        console.log("offsetAngle", od)
        console.log("angle", ad)
        console.log("this.rotation", rd)


        this.placeHandle();
    }

    distance (pt1, pt2)
    {
        return Math.sqrt( Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
    }

    applyScale (event)
    {
        console.log("applyScale",event);

        let startDragPosition = event.handle.startDragPosition;
        let pos = {x: this.x, y: this.y};
        let mouse = {x: event.event.x, y: event.event.y};


        let distanceStart = this.distance(startDragPosition, pos);
        let distanceCurrent = this.distance(mouse, pos);


        let scale = (distanceCurrent / distanceStart) * event.handle.spriteStartInfo.scale

        console.log(distanceStart, distanceCurrent, event.handle.spriteStartInfo.scale);

        this.sprite.scale.x = scale;
        this.sprite.scale.y = Math.abs(scale)
        //this.sprite.roundPixels = true;

        this.drawTransformBorder();

        /* return;

        let handleType = event.handle.handleType;

        let arrFollowX = [];
        let arrFollowY = [];

        if (handleType === "tl")
        {
            arrFollowX = [this.handleBL]
            arrFollowY = [this.handleTR]
        }
        else if (handleType === "tr")
        {
            arrFollowX = [this.handleBR]
            arrFollowY = [this.handleTL]
        }
        else if (handleType === "bl")
        {
            arrFollowX = [this.handleTL]
            arrFollowY = [this.handleBR]
        }
        else if (handleType === "br")
        {
            arrFollowX = [this.handleTR]
            arrFollowY = [this.handleBL]
        }



        arrFollowX.forEach( handle => handle.x = event.handle.x);
        arrFollowY.forEach( handle => handle.y = event.handle.y);


        let width = (this.handleTR.x - this.handleTL.x);
        let height = (this.handleBL.y - this.handleTL.y);


        this.sprite.width = Math.abs(width);
        this.sprite.height = Math.abs(height);

        if (width < 0 && this.sprite.scale.x > 0)
        {
            this.sprite.scale.x = -this.sprite.scale.x;
        }
        else if (width > 0 && this.sprite.scale.x < 0)
        {
            this.sprite.scale.x = -this.sprite.scale.x;
        }


        if (height < 0 && this.sprite.scale.y > 0)
        {
            this.sprite.scale.y = -this.sprite.scale.y;
        }
        else if (height > 0 && this.sprite.scale.y < 0)
        {
            this.sprite.scale.y = -this.sprite.scale.y;
        }

        this.sprite.x = 0;
        this.sprite.y = 0;

        if (this.sprite.scale.x > this.sprite.scale.y)
        {
            this.sprite.scale.y = this.sprite.scale.x;
        }
        else
        {
            this.sprite.scale.x = this.sprite.scale.y;
        }

        this.drawTransformBorder();*/
    }

    hideButton ()
    {
        this.btnScale.visible = false;
        this.btnRotate.visible = false;
        this.btnFlip.visible = false;
        this.btnValider.visible = false;
        this.hideHandle();
    }

    showButton ()
    {
        this.btnScale.visible = true;
        this.btnRotate.visible = true;
        this.btnFlip.visible = true;
        this.btnValider.visible = true;

        this.placeButton ();
        this.showHandle();
    }

    showHandle ()
    {
        this.handleTL.visible = true;
        this.handleTR.visible = true;
        this.handleBL.visible = true;
        this.handleBR.visible = true;
    }

    hideHandle ()
    {
        this.handleTL.visible = false;
        this.handleTR.visible = false;
        this.handleBL.visible = false;
        this.handleBR.visible = false;
    }

    placeButton ()
    {

        if (this.btnScale.visible)
        {
            let fitTop = (this.y - (this.sprite.height / 2) - (this.btnScale.height + 10) > 0);

            if (fitTop)
            {
                this.placeAbove();
            }
            else
            {
                this.placeBellow();
            }


            requestAnimationFrame(() => this.placeButton())
        }

    }

    placeAbove ()
    {
        this.placeHorizontally();

        let halfHeight = -this.sprite.height / 2;

        this.btnRotate.y = halfHeight + -this.btnRotate.height - this.offset_btn;
        this.btnFlip.y = halfHeight + -this.btnFlip.height - this.offset_btn;

        this.btnScale.y = halfHeight + -this.btnScale.height - this.offset_btn;
        this.btnValider.y = halfHeight + -this.btnValider.height - this.offset_btn;
    }

    placeBellow ()
    {
        this.placeHorizontally();

        let halfHeight = this.sprite.height / 2;

        this.btnRotate.y = halfHeight  + this.offset_btn;
        this.btnFlip.y = halfHeight + this.offset_btn;

        this.btnScale.y = halfHeight + this.offset_btn;
        this.btnValider.y = halfHeight  + this.offset_btn;
    }

    placeHorizontally ()
    {
        let width = this.btnScale.width + this.btnRotate.width + this.btnFlip.width + this.btnValider.width + (3 * this.offset_btn);
        let halfWidth = this.sprite.width / 2;

        const startX = (this.sprite.width - width) / 2;

        this.btnScale.x = -halfWidth + startX;
        this.btnRotate.x = this.btnScale.x + this.btnScale.width + this.offset_btn;
        this.btnFlip.x = this.btnRotate.x + this.btnRotate.width + this.offset_btn;
        this.btnValider.x = this.btnFlip.x + this.btnFlip.width + this.offset_btn;


    }


    removeTransform ()
    {
        this.hideHandle();
        this.gfxBorder.clear();
        this.sprite.on("pointerdown", this.fctStartTransform)
    }

    startTransform (event)
    {
        console.log("startTransform");

        this.makeActive();
        this.onDragStart(event);

    }

    makeActive ()
    {
        if (!this.handleTL)
        {
            setTimeout(() => this.makeActive(), 10)
            return;
        }

        this.showHandle();

        this.emit("change-active", this)

        this.parent.addChild(this);
        this.drawTransformBorder();

        this.sprite.off("pointerdown", this.fctStartTransform)
    }

    drawTransformBorder ()
    {
        let r = this.sprite.rotation;
        this.sprite.rotation = 0;
        let rect = this.sprite.getBounds();
        this.sprite.rotation = r;


        this.gfxBorder.clear();
        this.gfxBorder.lineStyle({width: 5, color: 0x85caff})
        this.gfxBorder.drawRoundedRect(rect.width / -2, rect.height / -2, rect.width, rect.height, 5);

        console.log(rect);


        this.placeHandle();
    }

    getRotatedRect ()
    {
        let rect = {};

        rect.x = this.handleTL.x;
        rect.y = this.handleTL.y;

    }
    onDragStart (event)
    {
        console.log("onDragStart", event)

        this.arrPrevious.push ({x:this.x, y: this.y});

        //this.ptOffset = this.toLocal({x:event.nativeEvent.clientX, y: event.nativeEvent.clientY}); //pixi.js v.7
        this.ptOffset = this.toLocal({x:event.data.global.x, y: event.data.global.y}); //pixi.js v.6


        this.sprite.off("pointerdown", this.fctDragStart);
        this.sprite.on("pointermove", this.fctDrag);
        this.sprite.on("pointerup", this.fctDragEnd);
        this.sprite.on("pointerupoutside", this.fctDragEnd);

        this.parent.addChild(this);

        cancelAnimationFrame(this.idFrameVelocity)
        this.calculateVelocity();
    }

    calculateVelocity ()
    {
        this.idFrameVelocity = requestAnimationFrame( () => this.calculateVelocity());

        this.arrPrevious.push ({x: this.x, y: this.y});

        while (this.arrPrevious.length > 5)
        {
            this.arrPrevious.shift();
        }
    }

    onDrag (event)
    {


        //let position = {x:event.nativeEvent.clientX, y: event.nativeEvent.clientY}; //v.7
        let position = {x:event.data.global.x, y: event.data.global.y}; //v.6

        this.x = position.x - this.ptOffset.x;
        this.y = position.y - this.ptOffset.y;

    }

    onDragEnd ()
    {

        this.sprite.off("pointermove", this.fctDrag);
        this.sprite.off("pointerup", this.fctDragEnd);
        this.sprite.off("pointerupoutside", this.fctDragEnd);
        this.sprite.on("pointerdown", this.fctDragStart);

        cancelAnimationFrame(this.idFrameVelocity)

        this.averageVelocity();
        this.inertia();
    }

    averageVelocity ()
    {
        let arrVelocity = this.arrPrevious.map ( (p, index) => index > 0 ? ({x: p.x - this.arrPrevious[index - 1].x, y: p.y - this.arrPrevious[index - 1].y}) : ({x: 0, y: 0}));
        let total = arrVelocity.reduce ( (a,r) =>  { a.x += r.x; a.y += r.y; return a; }, {x: 0, y: 0});

        this.velocity = {};
        this.velocity.x = total.x / (arrVelocity.length -1);
        this.velocity.y = total.y / (arrVelocity.length -1);

    }

    inertia ()
    {
        this.x += this.velocity.x;
        this.y += this.velocity.y;

        this.velocity.x *= 0.85;
        this.velocity.y *= 0.85;

        let vector = Math.sqrt (Math.pow(this.velocity.x, 2) + Math.pow(this.velocity.y, 2));

        console.log("inertia", this.velocity);

        if (vector > 0.5)
        {
            requestAnimationFrame(() => this.inertia());
        }


    }

    flip ()
    {
        this.sprite.scale.x *= -1;

        if (this.animation)
        {
            this.animation.scale.x = this.sprite.scale.x;

        }

        this.isFlip = this.sprite.scale.x < 0;
    }
}
